import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CTA from './components/CTA';
import FAQ from './components/FAQ';
import Features from './components/Features';
import Footer from './components/Footer';
import Hero from './components/Hero';
import TargetUser from './components/TargetUser';
function App() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "min-h-screen w-full",
        children: [
            /*#__PURE__*/ _jsx(Hero, {}),
            /*#__PURE__*/ _jsx(TargetUser, {}),
            /*#__PURE__*/ _jsx(Features, {}),
            /*#__PURE__*/ _jsx(FAQ, {}),
            /*#__PURE__*/ _jsx(CTA, {}),
            /*#__PURE__*/ _jsx(Footer, {})
        ]
    });
}
export default App;
